export default __webpack_public_path__ + "static/media/community-header.1f120d09.jpg";